export default {"src":"/login-app/[GIT_HASH]/_next/static/media/launch.e6ef4ce2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};